import * as React from 'react';
import Alert from 'antd/lib/alert';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import Text from 'antd/lib/typography/Text';

import { AgentType } from '@/types';

import { AgentCISetupHelp } from './AgentCISetupHelp';
import { AgentRoutineSetupHelp } from './AgentRoutineSetupHelp';

interface IssuedKey {
    agentName: string;
    agentType: AgentType;
    apiKey: string;
    warning?: string;
}

const AgentKeyModal: React.FC<{ issuedKey: IssuedKey; onClose: () => void }> = ({ issuedKey, onClose }) => (
    <Modal
        open
        title={`API key for ${issuedKey.agentName}`}
        onCancel={onClose}
        footer={
            <Button type="primary" onClick={onClose}>
                Done
            </Button>
        }
    >
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <Text>Give this key to your agent so it can read the issues assigned to it.</Text>
            <Typography.Paragraph code copyable style={{ marginBottom: 0, wordBreak: 'break-all' }}>
                {issuedKey.apiKey}
            </Typography.Paragraph>
            <Alert type="warning" showIcon message="Copy the key now. You won't be able to see it again." />
            {issuedKey.warning && <Alert type="error" showIcon message={issuedKey.warning} />}
            {issuedKey.agentType === AgentType.CIWorkflow && <AgentCISetupHelp />}
            {issuedKey.agentType === AgentType.ClaudeRoutine && <AgentRoutineSetupHelp />}
        </Space>
    </Modal>
);

export default AgentKeyModal;
